<template>
  <div class="input-wrap">
    <div class="tag-selector">
      <div class="tag-list">
        <div class="tag" v-for="(tag, index) in tags" :key="index">
          {{ tag }}
          <span class="tag-remove" @click="removeTag(index)">x</span>
        </div>
        <input
          ref="input"
          type="text"
          class="tag-input"
          @keydown.enter="addTag"
          @keydown.delete="removeLastTag"
          v-tag-comma="addTag"
          v-model.trim="newTag"
          :style="tags.length ? '' : 'height:100%;'"
        />
      </div>
      <!--@keydown.188.prevent="addTag"
          @keydown.229.prevent="addTag"
          @keydown.enter="addTag" v-model.trim="newTag"-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.directive("tag-comma", {
  bind: function (el, binding, vnode) {
    el.addEventListener("keydown", function (event) {
      if (event.keyCode === 188 || event.keyCode === 229) {
        // 判断逗号键
        event.preventDefault();
        vnode.context[binding.expression](event);
      }
    });
  },
});
export default {
  name: "tagSelect",
  data() {
    return {
      tags: [],
      newTag: "",
    };
  },
  computed: {},
  methods: {
    addTag() {
      this.$nextTick(() => {
        if (this.newTag !== "") {
          this.tags.push(this.newTag);
          this.newTag = "";
          this.$emit("gettag", this.tags);
        }
      });
    },
    //移除标签
    removeTag(index) {
      this.tags.splice(index, 1);
      this.$emit("gettag", this.tags);
    },
    //移除最后一个标签
    removeLastTag(event) {
      const tagInput = this.newTag;
      if (!tagInput) {
        event.preventDefault();
        this.tags.pop();
        this.$emit("gettag", this.tags);
      }
    },

    //判断是否还有未生成标签
    ungenerated() {
      const { newTag } = this;
      if (newTag) {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.input-wrap {
  height: auto !important;
  min-height: 40px;
}
.tag-selector {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  flex-flow: row wrap;
  gap: calc(4px);
  -webkit-box-pack: start;
  justify-content: flex-start;
  width: 100%;
  padding: calc(4px);
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 5px;
  width: 100%;
}

.tag {
  display: inline-block;
  background-color: #eee;
  color: #333;
  border-radius: 3px;
  padding: 2px 5px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.tag-remove {
  cursor: pointer;
  margin-left: 5px;
}

.tag-input {
  background: inherit;
  border: 0;
  box-shadow: none;
  color: #1e1e1e;
  display: inline-block;
  flex: 1;
  font-family: inherit;
  font-size: 13px;
  margin-left: 4px;
  max-width: 100%;
  min-height: 24px;
  min-width: 50px;
  padding: 0;
  width: 100%;
}
</style>
